module.exports = {
  AUTOSAVE_TYPE: {
    SEND_PAYMENT: 'SEND_PAYMENT'
  }
};
